import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '@lyricstream/shared';

@Component({
  selector: 'app-login-popup-overlay',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './login-popup-overlay.html',
  styleUrl: './login-popup-overlay.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginPopupOverlayComponent {
  protected readonly auth = inject(AuthService);
}
